import type { TGametype, TGameformatGroup } from '@/types/basic'

function getGameformatGroup(gametype: TGametype, fallback?: TGameformatGroup): TGameformatGroup {
  // We need to validate this with BE team as not every gametype might be covered
  // /^(Cash|.*Straddle.*)/
  // /^(MTT.*)/
  // /^(Spins.*)/
  // /^(HuSng.*)/

  switch (true) {
    case /^(Cash|.*Straddle.*)/.test(gametype):
      return 'Cash'
    case /^(MTT.*)/.test(gametype):
      return 'MTT'
    case /^(Spins.*)/.test(gametype):
      return 'Spins'
    case /^(HuSng.*)/.test(gametype):
      return 'HuSng'
    default:
      if (fallback) {
        return fallback
      }
      throw new Error(`Invalid gameformat - ${gametype || 'undefined'}`)
  }
}

export { getGameformatGroup }
